import TextLockupV2 from "components/elements/textLockupV2"
import PropTypes from "prop-types"
import React, { useState } from "react"
import { Accordion } from "react-bootstrap"
import AccordionItem from "./accordion-item"
import "./section-split-accordion-v2.scss"

const SectionSplitAccordionV2 = ({ accordionItems, text, title }) => {
  const [activeIndex, setActiveIndex] = useState("")
  return (
    <section className="section-split-accordion-v2">
      <div className="container-v2">
        <div className="section-split-accordion-v2--content">
          {title && (
            <h2 className="section-split-accordion-v2--heading">
              <TextLockupV2>{title}</TextLockupV2>
            </h2>
          )}
          {text?.childrenMarkdownRemark?.[0]?.html && (
            <div
              className="section-split-accordion-v2--text"
              dangerouslySetInnerHTML={{
                __html: text.childrenMarkdownRemark[0].html,
              }}
            />
          )}
        </div>
        {accordionItems &&
          accordionItems?.length &&
          accordionItems?.length > 0 && (
            <div className="section-split-accordion-v2--accordion-items">
              <Accordion activeKey={activeIndex} onSelect={setActiveIndex}>
                {accordionItems.map(item => (
                  <AccordionItem
                    activeIndex={activeIndex}
                    content={item.content}
                    heading={item.heading}
                    icon={item.icon}
                    index={item.id}
                    isAccordion={true}
                    key={item.id}
                    subHeading={item.subHeading}
                  />
                ))}
              </Accordion>
            </div>
          )}
      </div>
    </section>
  )
}

export default SectionSplitAccordionV2
SectionSplitAccordionV2.propTypes = {
  accordionItems: PropTypes.array.isRequired,
  text: PropTypes.object.isRequired,
  title: PropTypes.string.isRequired,
}
